import type { ReactElement } from 'react';
import { ChannelType } from '@gr/core/distribution/channels/channel-types';
import { useT } from '../../../../app/di';
import styles from './ChannelTypeIcon.module.scss';

// Упрощённые знаки платформ 24×24 (штрих), белым на фирменном цвете.
const GLYPHS: Readonly<Record<ChannelType, readonly string[]>> = {
  [ChannelType.Telegram]: ['M5 11.5l13-5.5-2.5 12-4.5-3.5', 'M11 14.5l-1.5 3.5v-4.5l6-5.5'],
  [ChannelType.Instagram]: ['M8 5h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M16.5 7.5h.01'],
  [ChannelType.Vk]: ['M4.5 8l2.5 8 2.5-8', 'M13 8v8', 'M19 8l-5 4 5 4'],
  [ChannelType.Max]: ['M6 17V7l6 6 6-6v10'],
  [ChannelType.Other]: ['M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16z', 'M4 12h16', 'M12 4a12 12 0 0 1 0 16', 'M12 4a12 12 0 0 0 0 16'],
};

export interface ChannelTypeIconProps {
  type: ChannelType;
}

/** POST-UC-4, CHN-UC-1: значок платформы канала; название платформы — в подписи для экранных чтецов и подсказке. */
export function ChannelTypeIcon({ type }: ChannelTypeIconProps): ReactElement {
  const { t } = useT();
  const name = t(`channels.types.${type}`);
  return (
    <span className={styles.icon} data-type={type} role="img" aria-label={name} title={name}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {GLYPHS[type].map((d) => (
          <path key={d} d={d} />
        ))}
      </svg>
    </span>
  );
}
